import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { Fulfillment, FulfillmentItem } from '@/types/order';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

export type CreateFulfillmentPayload = Pick<Fulfillment, 'carrier' | 'shipping_method' | 'cost' | 'is_ltl' | 'tracking_info'> & {
  type: 'shipment' | 'replacement';
  fulfillment_items: Array<Pick<FulfillmentItem, 'quantity'> & { ship_advice_item_id: number }>;
};

export const postShipAdviceFulfillment = async (
  scope: RequestScope,
  { shipAdviceId, data }: { shipAdviceId: string | number; data: CreateFulfillmentPayload },
  options: WriteRequestOptions
): Promise<EndpointResponse<Fulfillment>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Fulfillment>>(`ship_advice/${shipAdviceId}/fulfillment`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
